import { render } from "./ListsPage.vue?vue&type=template&id=5fe85081&ts=true"
import script from "./ListsPage.vue?vue&type=script&lang=ts"
export * from "./ListsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__